import { useI18n } from 'vue-i18n';

type Translate = ReturnType<typeof useI18n>['t'];

export function useTranslateOr(): {
  t: Translate;
  translateOr: (key: string, fallback: string) => string;
} {
  const { t, te } = useI18n();
  // t() returns the key for a missing message, thus te() selects the fallback.
  const translateOr = (key: string, fallback: string): string =>
    te(key) ? String(t(key)) : fallback;
  return { t, translateOr };
}
